import { Link } from 'react-router-dom';
import type { PaymentAgreementReference } from '@/api/generated/models';
import { AgreementDocumentField } from '@/components/agreement/AgreementDocumentField';
import { LABEL_CLASS, VALUE_DEFAULT_CLASS } from '@/components/Field';
import { Panel } from '@/components/ui/panel';
import { SectionHeading } from '@/components/ui/section-heading';
import { NOT_AVAILABLE } from '@/lib/display';

export function PaymentAgreementsSection({
  agreement,
}: {
  agreement: PaymentAgreementReference | null;
}) {
  return (
    <div>
      <SectionHeading>Payment Agreements</SectionHeading>
      <Panel variant="action">
        <div className="space-y-3">
          <div>
            <p className={LABEL_CLASS}>Payment Agreement Details Page</p>
            {agreement ? (
              <Link
                to={`/agreements/${encodeURIComponent(agreement.agreementId)}`}
                className="mt-1 block text-[18px] font-medium leading-6 text-black underline"
              >
                {agreement.agreementId}
              </Link>
            ) : (
              <p className={`mt-1 ${VALUE_DEFAULT_CLASS}`}>{NOT_AVAILABLE}</p>
            )}
          </div>
          {agreement ? (
            <>
              <AgreementDocumentField
                agreementId={agreement.agreementId}
                party="customer"
                documentId={agreement.customerAgreementId}
              />
              <AgreementDocumentField
                agreementId={agreement.agreementId}
                party="dealer"
                documentId={agreement.dealerAgreementId}
              />
            </>
          ) : null}
        </div>
      </Panel>
    </div>
  );
}
